import { Field, TextInput, SelectInput, FormDialog, ActionButton } from "./common";

const AssetField = ({ field, value, setValue }) => {
  if (field.type === "checkbox") return (
    <label className="flex items-center gap-2 pt-6"><input type="checkbox" data-testid={`asset-field-${field.key}`} checked={!!value} onChange={(e) => setValue(e.target.checked)} className="accent-amber-500 w-4 h-4" /><span className="text-sm text-slate-300">{field.label}</span></label>
  );
  if (field.type === "select") return (
    <Field label={field.label}><SelectInput testId={`asset-field-${field.key}`} value={value} onChange={(e) => setValue(e.target.value)} required={field.required} options={field.options.map((option) => typeof option === "string" ? { value: option, label: option.replace(/_/g, " ").toUpperCase() } : option)} /></Field>
  );
  return (
    <div className={field.wide ? "col-span-2" : ""}><Field label={field.label}><TextInput testId={`asset-field-${field.key}`} type={field.type || "text"} step={field.type === "number" ? "any" : undefined} value={value} onChange={(e) => setValue(e.target.value)} required={field.required} /></Field></div>
  );
};

export const AssetForm = ({ open, onOpenChange, editing, form, setForm, sections, submit, busy }) => (
  <FormDialog open={open} onOpenChange={onOpenChange} title={editing ? `Edit ${editing.asset_name}` : "Add Asset to Register"} testId="asset-form-dialog">
    <form onSubmit={submit} className="space-y-6">
      {sections.map((section) => <div key={section.title}>
        <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-amber-500/80 border-b border-slate-800 pb-1 mb-3">{section.title}</p>
        <div className="grid grid-cols-2 gap-4">{section.fields.map((field) => <AssetField key={field.key} field={field} value={form[field.key]} setValue={(value) => setForm((prev) => ({ ...prev, [field.key]: value }))} />)}</div>
      </div>)}
      <ActionButton testId="asset-submit-button" type="submit" disabled={busy} className="w-full justify-center">{busy ? "Saving…" : editing ? "Save Changes" : "Add Asset"}</ActionButton>
    </form>
  </FormDialog>
);
